<template>
  <div class="accordion-item" :style="textStyle">
    <div class="accordion-item-content" @click="itemClicked(itemId)">
      <div class="title-icon">
        <span>{{title}}</span>
      </div>
      <div :class="`arrow ${active ? 'rotate' : ''}`"></div>
    </div>
    <div :id="itemId" class="description-container">
      <div class="description-content">
        <div class="description-row" v-for="(row, index) in items" :key="title + index">
          <a :href="row.url" :target="row.targetLocal ? '_self' : '_blank'">
            <span v-if="row.title" class="title">{{row.title.trim()}}</span>
            &nbsp;
            <span v-if="row.notes" class="notes">({{row.notes.trim()}})</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  data() {
    return {
      items: []
    };
  },
  props: {
    propsArray: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    itemId: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    propsArray: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.items = newVal;
        setTimeout(() => {
          this.itemClicked(this.itemId, true);
        }, 1000);
      }
    }
  },
  computed: {
    secondaryFontColor(){
      return `--green_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    textStyle() {
      return `${this.secondaryFontColor} ${this.mainFontColor}`;
    },
  },
  mounted() {
    this.items = this.propsArray;
  },
  methods: {
    itemClicked(id, refresh) {
      this.$parent.itemClicked(id, refresh);
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-item {
  color: black;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 10px 0;

  cursor: pointer;

  .accordion-item-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.222);
    padding: 5px 0;
    padding-bottom: 5px;
    @media (max-width: $lg) {
      min-height: 43px;
    }
    span {
      font-family: Geogrotesque-Medium;
      font-size: 19px;
      color: var(--main_font);
      letter-spacing: 0.59px;
      @media (max-width: $lg) {
        font-size: 16px;
        letter-spacing: 0.5px;
      }
    }
  }
  .title-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    text-transform: uppercase;
    span {
      font-family: "AvenirLTStd-Black";
      font-size: 16px;
      color: var(--main_font);
      letter-spacing: 0;
      line-height: 24px;
    }
    img,
    svg {
      height: 36px;
      width: 36px;
      margin-right: 7px;
      fill: var(--main_font);
      opacity: 0.25;
    }
  }
  .description-container {
    height: 0;
  }
  .description {
    height: 100%;
    font-family: Geogrotesque-Medium;
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 0.47px;
  }
  .description-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0 10px 10px;
    @media (max-width: $lg) {
      padding: 28px 0px 8px 10px;
    }
    .description-row {
      width: 100%;
      font-family: "AvenirLTStd-Black";
      cursor: pointer;

      .title {
        font-family: "AvenirLTStd-Black";

        line-height: 24px;
        text-decoration: none;
        font-size: 14px;
        color: var(--main_font);
        letter-spacing: 0;
        transition: all 0.25s ease-in-out;
      }
      .notes {
        font-family: "AvenirLTStd-Black";
        opacity: 0.5;
        font-size: 14px;
        color: #d8d8d8;
        text-align: left;
        letter-spacing: 0;
        line-height: 24px;
      }
      a,
      a:hover {
        text-decoration: none;
      }
      &:hover {
        text-decoration: none;
      }
    }
  }
}
.arrow {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid #ffffff;
  transform: rotate(-90deg);
  transition-duration: 0.3s;
  padding-right: 10px;
}
.rotate {
  transform: rotate(-270deg) translateX(-50%) !important;
  transition-duration: 0.3s;
}
</style>